import { jsx as _jsx } from "react/jsx-runtime";
import { useIsClient } from '@/hooks/useIsClient';
import clsx from 'clsx';
import * as React from 'react';
const IconMap = {
    accessibility: React.lazy(() => import('@/icons/accessibility.svg')),
    account: React.lazy(() => import('@/icons/account.svg')),
    add: React.lazy(() => import('@/icons/add.svg')),
    'arrow-down': React.lazy(() => import('@/icons/arrow-down.svg')),
    'arrow-left': React.lazy(() => import('@/icons/arrow-left.svg')),
    'arrow-right-diagonal': React.lazy(() => import('@/icons/arrow-right-diagonal.svg')),
    'arrow-right': React.lazy(() => import('@/icons/arrow-right.svg')),
    'arrow-up': React.lazy(() => import('@/icons/arrow-up.svg')),
    appstore: React.lazy(() => import('@/icons/appstore.svg')),
    'baby-change': React.lazy(() => import('@/icons/baby-change.svg')),
    bookmark: React.lazy(() => import('@/icons/bookmark.svg')),
    bus: React.lazy(() => import('@/icons/bus.svg')),
    'bag-tbc': React.lazy(() => import('@/icons/bag-tbc.svg')),
    calendar: React.lazy(() => import('@/icons/calendar.svg')),
    calendar2: React.lazy(() => import('@/icons/calendar2.svg')),
    call: React.lazy(() => import('@/icons/call.svg')),
    card: React.lazy(() => import('@/icons/card.svg')),
    cash: React.lazy(() => import('@/icons/cash.svg')),
    'charge-phone': React.lazy(() => import('@/icons/charge-phone.svg')),
    charge: React.lazy(() => import('@/icons/charge.svg')),
    chat: React.lazy(() => import('@/icons/chat.svg')),
    'chevron-down': React.lazy(() => import('@/icons/chevron-down.svg')),
    'chevron-left': React.lazy(() => import('@/icons/chevron-left.svg')),
    'chevron-right': React.lazy(() => import('@/icons/chevron-right.svg')),
    'chevron-up': React.lazy(() => import('@/icons/chevron-up.svg')),
    'child-care': React.lazy(() => import('@/icons/child-care.svg')),
    close: React.lazy(() => import('@/icons/close.svg')),
    contact: React.lazy(() => import('@/icons/contact.svg')),
    'currency-exchange': React.lazy(() => import('@/icons/currency-exchange.svg')),
    detail: React.lazy(() => import('@/icons/detail.svg')),
    download: React.lazy(() => import('@/icons/download.svg')),
    error: React.lazy(() => import('@/icons/error.svg')),
    filter: React.lazy(() => import('@/icons/filter.svg')),
    food: React.lazy(() => import('@/icons/food.svg')),
    gift: React.lazy(() => import('@/icons/gift.svg')),
    googleplay: React.lazy(() => import('@/icons/googleplay.svg')),
    heart: React.lazy(() => import('@/icons/heart.svg')),
    'heart-fill': React.lazy(() => import('@/icons/heart-fill.svg')),
    /** @deprecated use "heart-fill" instead */
    'heart-solid': React.lazy(() => import('@/icons/heart-fill.svg')),
    'hand-tbc': React.lazy(() => import('@/icons/hand-tbc.svg')),
    info: React.lazy(() => import('@/icons/info.svg')),
    innovate: React.lazy(() => import('@/icons/innovate.svg')),
    'jigsaw-tbc': React.lazy(() => import('@/icons/jigsaw-tbc.svg')),
    language: React.lazy(() => import('@/icons/language.svg')),
    list: React.lazy(() => import('@/icons/list.svg')),
    'local-atm': React.lazy(() => import('@/icons/local_atm.svg')),
    logo: React.lazy(() => import('@/icons/logo.svg')),
    luggage: React.lazy(() => import('@/icons/luggage.svg')),
    mail: React.lazy(() => import('@/icons/mail.svg')),
    map: React.lazy(() => import('@/icons/map.svg')),
    menu: React.lazy(() => import('@/icons/menu.svg')),
    more: React.lazy(() => import('@/icons/more.svg')),
    mute: React.lazy(() => import('@/icons/mute.svg')),
    offers: React.lazy(() => import('@/icons/offers.svg')),
    tag: React.lazy(() => import('@/icons/offers.svg')),
    pause: React.lazy(() => import('@/icons/pause.svg')),
    play: React.lazy(() => import('@/icons/play.svg')),
    /** @deprecated use "play" instead */
    'play-circle': React.lazy(() => import('@/icons/play.svg')),
    remove: React.lazy(() => import('@/icons/remove.svg')),
    search: React.lazy(() => import('@/icons/search.svg')),
    service: React.lazy(() => import('@/icons/service.svg')),
    soap: React.lazy(() => import('@/icons/soap.svg')),
    sound: React.lazy(() => import('@/icons/sound.svg')),
    stairs: React.lazy(() => import('@/icons/stairs.svg')),
    'star-fill': React.lazy(() => import('@/icons/star-fill.svg')),
    star: React.lazy(() => import('@/icons/star.svg')),
    stop: React.lazy(() => import('@/icons/stop.svg')),
    store: React.lazy(() => import('@/icons/store.svg')),
    stroller: React.lazy(() => import('@/icons/stroller.svg')),
    swing: React.lazy(() => import('@/icons/swing.svg')),
    'stars-tbc': React.lazy(() => import('@/icons/stars-tbc.svg')),
    tick: React.lazy(() => import('@/icons/tick.svg')),
    time: React.lazy(() => import('@/icons/time.svg')),
    'valet-shine': React.lazy(() => import('@/icons/valet-shine.svg')),
    'valet-soap': React.lazy(() => import('@/icons/valet-soap.svg')),
    virtual: React.lazy(() => import('@/icons/virtual.svg')),
    wheelchair: React.lazy(() => import('@/icons/wheelchair.svg')),
    wifi: React.lazy(() => import('@/icons/wifi.svg')),
    zoom: React.lazy(() => import('@/icons/zoom.svg')),
    parking: React.lazy(() => import('@/icons/parking.svg')),
    charging: React.lazy(() => import('@/icons/charging.svg')),
    'feature-event': React.lazy(() => import('@/icons/feature-event.svg')),
    mobility: React.lazy(() => import('@/icons/mobility.svg')),
    'currency-euro': React.lazy(() => import('@/icons/currency-euro.svg')),
    'currency-sterling': React.lazy(() => import('@/icons/currency-sterling.svg')),
    bag: React.lazy(() => import('@/icons/bag.svg')),
    hanger: React.lazy(() => import('@/icons/hanger.svg')),
    receipt: React.lazy(() => import('@/icons/receipt.svg')),
    news: React.lazy(() => import('@/icons/news.svg')),
    percent: React.lazy(() => import('@/icons/percent.svg')),
    'tax-receipt': React.lazy(() => import('@/icons/tax-receipt.svg')),
    edit: React.lazy(() => import('@/icons/edit.svg')),
    delete: React.lazy(() => import('@/icons/delete.svg')),
    'map-marker': React.lazy(() => import('@/icons/map-marker.svg')),
    inclusivity: React.lazy(() => import('@/icons/inclusivity.svg')),
    magic: React.lazy(() => import('@/icons/magic.svg')),
    'retail-experience': React.lazy(() => import('@/icons/retail-experience.svg')),
    share: React.lazy(() => import('@/icons/social/share.svg')),
    facebook: React.lazy(() => import('@/icons/social/facebook.svg')),
    instagram: React.lazy(() => import('@/icons/social/instagram.svg')),
    whatsapp: React.lazy(() => import('@/icons/social/whatsapp.svg')),
    x: React.lazy(() => import('@/icons/social/x.svg')),
    link: React.lazy(() => import('@/icons/social/link.svg')),
    linkedin: React.lazy(() => import('@/icons/social/linkedin.svg')),
    tiktok: React.lazy(() => import('@/icons/social/tiktok.svg')),
    telegram: React.lazy(() => import('@/icons/social/telegram.svg')),
    tripadvisor: React.lazy(() => import('@/icons/social/tripadvisor.svg')),
    paypal: React.lazy(() => import('@/icons/payment/paypal.svg')),
    stripe: React.lazy(() => import('@/icons/payment/stripe.svg')),
    mastercard: React.lazy(() => import('@/icons/payment/mastercard.svg')),
    amex: React.lazy(() => import('@/icons/payment/amex.svg')),
    visa: React.lazy(() => import('@/icons/payment/visa.svg')),
    applepay: React.lazy(() => import('@/icons/payment/applepay.svg')),
    globe: React.lazy(() => import('@/icons/language/gb.svg')),
    'google-play': React.lazy(() => import('@/icons/app/google-play.svg')),
    'app-store': React.lazy(() => import('@/icons/app/app-store.svg')),
    'language-gb-eng': React.lazy(() => import('@/icons/language/gb-eng.svg')),
    'language-gb': React.lazy(() => import('@/icons/language/gb.svg')),
    'language-de': React.lazy(() => import('@/icons/language/de.svg')),
    'language-gf': React.lazy(() => import('@/icons/language/gf.svg')),
    'language-es': React.lazy(() => import('@/icons/language/es.svg')),
    'language-it': React.lazy(() => import('@/icons/language/it.svg')),
    'language-cn': React.lazy(() => import('@/icons/language/cn.svg')),
    'language-ru': React.lazy(() => import('@/icons/language/ru.svg')),
    'language-nl': React.lazy(() => import('@/icons/language/nl.svg')),
    'language-kr': React.lazy(() => import('@/icons/language/kr.svg')),
    'language-fr': React.lazy(() => import('@/icons/language/fr.svg')),
    'language-at': React.lazy(() => import('@/icons/language/at.svg')),
    'language-be': React.lazy(() => import('@/icons/language/be.svg')),
    'language-hu': React.lazy(() => import('@/icons/language/hu.svg')),
    'language-sk': React.lazy(() => import('@/icons/language/sk.svg')),
    'language-dk': React.lazy(() => import('@/icons/language/dk.svg')),
    'language-sa': React.lazy(() => import('@/icons/language/sa.svg')),
    'language-se': React.lazy(() => import('@/icons/language/se.svg')),
    'language-pl': React.lazy(() => import('@/icons/language/pl.svg')),
    'language-tr': React.lazy(() => import('@/icons/language/tr.svg')),
    'language-ro': React.lazy(() => import('@/icons/language/ro.svg')),
    'language-rs': React.lazy(() => import('@/icons/language/rs.svg')),
    'language-hr': React.lazy(() => import('@/icons/language/hr.svg')),
    'language-cz': React.lazy(() => import('@/icons/language/cz.svg')),
};
const Icon = ({ className, variant, ariaLabel, testid = 'icon' }) => {
    const isClient = useIsClient();
    if (!variant) {
        return null;
    }
    const IconComponent = IconMap[variant];
    if (!IconComponent) {
        if (process.env.NODE_ENV === 'development') {
            return (_jsx("span", { className: clsx('inline-block', className), "aria-hidden": true, children: variant }));
        }
        return null;
    }
    const fallback = _jsx("span", { className: clsx('inline-block', className), "aria-hidden": true });
    // Only render the icon on the client to avoid hydration issues with lazy loading
    if (!isClient) {
        return fallback;
    }
    return (_jsx(React.Suspense, { fallback: fallback, children: _jsx(IconComponent, { className: className, "aria-label": ariaLabel, "data-testid": testid, "aria-hidden": ariaLabel ? undefined : true }) }));
};
export default Icon;
